import DefaultResetForm from '@/components/DefaultResetForm';
import { CustomTextField } from '@/components/Formik/CustomTextField';
import { useUser } from '@/contexts/AuthContext';
import { api } from '@/services/apiClient';
import { resetDisplayName } from '@/validators/resetUsersInfo';
import { FormikValues } from 'formik';
import { IModalSuccessData } from '.';

interface ResetDisplayName {
  onSuccess: (value: IModalSuccessData) => void;
  handleClose: () => void;
}

const ResetDisplayName = ({ onSuccess, handleClose }: ResetDisplayName) => {
  const { user, updateUserData } = useUser();

  const handleSubmitResetDisplayNameForm = async (values: FormikValues) => {
    const userUpdate = {
      cpf: user?.cpf,
      name: user?.name,
      email: user?.email,
      display_name: values.display_name,
      username: user?.username,
    };
    await api.put('/auth/users/me/', userUpdate);

    onSuccess({
      isOpen: true,
      text: 'Seu apelido foi alterado com sucesso!',
    });
    updateUserData(userUpdate);
  };

  return (
    <DefaultResetForm
      title="Informe como você deseja
                    ser chamado"
      onSubmit={handleSubmitResetDisplayNameForm}
      handleCancel={handleClose}
      handleClose={handleClose}
      initialValues={{
        display_name: user.display_name,
      }}
      validationSchema={resetDisplayName}
    >
      <CustomTextField
        label="Apelido *"
        name="display_name"
        variant="standard"
      />
    </DefaultResetForm>
  );
};

export default ResetDisplayName;
